var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"incubadora2020"},[_c('Header'),_c('VideoIntro'),_c('hr'),_c('Manual'),_c('Manuales'),_c('PreVideoRow'),_c('VideoRow',{attrs:{"video":_vm.videos[0]}}),_c('Sesiones'),_c('Menciones'),_c('MencionesTwo'),_c('Presentacion')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }